import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../../images/addIcon2.svg";

const AddIconBlue = (props) => {
  return (
    <Wrapper onClick={props.onClick}>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default AddIconBlue;
